import {
  PROFILE_EDITED,
  PROFILE_LOADED,
  PROFILE_RESET,
  ProfileAction,
} from './profile.actions';

import { IProfileState } from '../../app.state';

const INITIAL_STATE: IProfileState = {
  isLoaded: false,
  isEdited: false,
  body: {},
};

export function profileReducer(
  state: any = INITIAL_STATE,
  action: ProfileAction,
) {
  switch (action.type) {
    case PROFILE_LOADED: {
      return {
        ...state,
        isLoaded: true,
        isEdited: false,
        body: action.payload,
      };
    }

    case PROFILE_RESET: {
      return INITIAL_STATE;
    }

    case PROFILE_EDITED: {
      return {
        ...state,
        isEdited: action.payload,
      };
    }

    default: {
      return state;
    }
  }
}
